import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { getAccountJson } from 'services/account-settings';
import { setSectionsData } from 'store/actions/app-data';
import { getSectionsData } from 'store/selectors/app-data';
import { getIsLoggedIn } from 'store/selectors/user-data';

export const useFetchSectionsData = (): void => {
  const dispatch = useDispatch();
  const sectionsData = useSelector(getSectionsData);
  const isLoggedIn = useSelector(getIsLoggedIn);

  useEffect(() => {
    if (isLoggedIn) {
      if (!sectionsData?.sections && SpringConfigs.SECTIONS_JSON) {
        getAccountJson(SpringConfigs.SECTIONS_JSON)
          .then(data => {
            dispatch(setSectionsData(data));
          })
          .catch(() => {
            dispatch(setSectionsData([]));
          });
      }

      if (!SpringConfigs.SECTIONS_JSON) {
        dispatch(setSectionsData([]));
      }
    }
  }, [isLoggedIn]);
};
